import { render, staticRenderFns } from "./notice_content.vue?vue&type=template&id=321466a4&scoped=true&"
import script from "./notice_content.vue?vue&type=script&lang=js&"
export * from "./notice_content.vue?vue&type=script&lang=js&"
import style0 from "./notice_content.vue?vue&type=style&index=0&id=321466a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321466a4",
  null
  
)

export default component.exports